import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '@/store/convo/state'
import { RootState } from '@/store'
import convoUtils from '@/store/convo/actions/convo-utils'
import { IConvo, Convo } from '@/model/convo'
import convoStore from '@/store/convo/convo-store'
import fetchUpdateConvo from '@/store/convo/actions/fetch-update-convo';

export default async function updateConvo(context: BareActionContext<ConvoState, RootState>)
{
    let currConvo = convoStore.state.convo;
    let convo: IConvo = new Convo()
    convo.title = convoStore.state.convoForm.title
    convo.body = convoStore.state.convoForm.body
    convoUtils.convoService.updateConvo(<number>currConvo.id, convo).then((result: any) => {
      fetchUpdateConvo(context, <number>currConvo.id)
    })

    return
}
